import Offer from './offer';
export default Offer;